import { gerkService } from '../services/gerk.service';


const state = {
    gerk: null,
    item:null,
    warrning:{opozorilo:false},
    sort:null
};

const actions = {
    load({ commit },{sezona,pridelovalecid}) {
        commit('load');

        gerkService.load(sezona,pridelovalecid)
            .then(
                gerk => commit('load', gerk)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
    loadVse({ commit },{sezona}) {
        commit('load');

        gerkService.loadVse(sezona)
            .then(
                gerk => commit('load', gerk)
                //,
                //error => commit('getLoggedInFailure', error)
            );
    },
    replace({ commit },{gerk}) {
        commit('replace',gerk);

    },
    checkStatus({ commit },{gerk,status}){
            console.log("v module")
            console.log(status);
           
              gerkService.loadWarrning(gerk,status)
              .then (warrning=>{
                commit("loadWarning",warrning)
                gerk.status=status;
                commit("save",gerk); 
                
            });
        
    },
    save({ commit }) {
      


     
             console.log(this.state.gerk);
             let data=this.state.gerk.gerk;
        data.forEach(item=>{
            
              gerkService.save(item)
            .then(
                gerk => {

                    if(gerk!=""){
                        //tu še dodaj info kljukico za shranjevanje, kot je pri kulturah!
                         var index=data.findIndex(i=>i.gerkpid==gerk.gerkpid)
                          data.splice(index,1,gerk)
                    }
                   //prepiši celi objekt, ne samo stanje
                        //item.stanje=gerk.stanje;
                    
                }
                //,
                //error => commit('getLoggedInFailure', error)
            );
}
);

       
        
    }
};

const mutations = {
  
    load(state, gerk) {
        state.gerk = gerk;
    },
    replace(state, gerk) {
        state.gerk = gerk;
    },
    loadWarning(state, warrning) {
        
        state.warrning = warrning;
       
     //   console.log(state);
    },
    save(state, item) {
        
        state.item = item;
    },
   
};

export const gerk = {
    namespaced: true,
    state,
    actions,
    mutations
};
